<script setup lang="ts">
import type { Brand } from "~/advertisorsData/shared/types";

const loading = ref(false);
interface Props {
  brand: Brand;
}

defineProps<Props>();
</script>

<template>
  <div
    :class="[brand.designSchema.darkMode ? 'text-white' : '']"
    class="container-800 mt-8 lg:mt-14 lg:text-center font-semibold"
  >
    <div class="text-4xl lg:text-6xl mb-8">
      Join the {{ brand.name }}<br />Ambassador Program
    </div>
    <div class="text-2xl mb-8 w-3/4 lg:w-full">
      Earn rewards for your posts on X.<br class="hidden lg:block" />
      Create your ambassador account on Evangelist today.
    </div>
    <SigninButton
      :style="{
        backgroundColor: brand.designSchema.primaryColor,
        borderRadius: brand.designSchema.borderRadius,
      }"
      class="btn transition-all duration-100 ease-out"
      :class="[
        brand.designSchema.darkMode
          ? 'text-black hover:!bg-white '
          : 'text-white hover:!bg-black',
      ]"
    >
      Check eligibility <IconsTweetIcon />
    </SigninButton>
  </div>

  <PageLoader v-if="loading" class="mt-14" />
  <div v-else>
    <div
      v-if="(brand.campaigns?.length ?? 0) > 0"
      class="container-800 my-10 lg:mt-14"
    >
      <div class="container-800 mt-8 lg:mt-14 lg:text-center font-semibold">
        <div
          class="text-2xl mb-8 w-3/4 lg:w-full"
          :class="[brand.designSchema.darkMode ? 'text-white' : '']"
        >
          Join these Ambassador Campaigns by {{ brand.name }}
        </div>
      </div>
    </div>

    <div class="container-950 mt-14">
      <div class="p-6 py-8 lg:p-12 bg-white rounded-2xl">
        <ContentsHowDoesItWorksSlider />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
